module.exports = __webpack_public_path__ + "static/media/dotsIcon.0866866e.svg";